module.exports = __webpack_public_path__ + "img/shcs_cb.prt.b7d26b14.jpg";